import { Avatar, BreadCrumbs, Crumb, Icon_ChevronLeft24 } from "@shapr3d/frontend-lib";

import { useTeam } from "../../hooks/useTeams";
import { useTracker } from "../../hooks/useTracker";
import { useWindowSize, ViewportType } from "../../hooks/useWindowSize";
import type { TeamID } from "../../types";

export const HeaderBreadCrumbs = ({ teamID, spaceName }: { teamID: TeamID; spaceName: string }) => {
  const tracker = useTracker();
  const { teamData } = useTeam(teamID);
  const teamName = teamData?.name;
  const { viewportType } = useWindowSize();

  const navigateTo = `/teams/${teamID}/shared-with-me`;

  if (!teamData) {
    return null;
  }

  return (
    <BreadCrumbs>
      {viewportType === ViewportType.Desktop && (
        <Crumb
          to={navigateTo}
          icon={<Avatar size="small" text={teamName} />}
          onClick={() => {
            tracker.trackGoToTeam({
              activeTeamId: teamID,
              destination: "shared_with_me",
              location: "breadcrumbs",
            });
          }}
        >
          {teamName}
        </Crumb>
      )}

      <Crumb
        to={navigateTo}
        icon={viewportType !== ViewportType.Desktop && <Icon_ChevronLeft24 />}
        onClick={() => {
          tracker.trackGoToSpace({
            activeTeamId: teamID,
            destination: "shared_with_me",
            location: "breadcrumbs",
            role: teamData.role,
          });
        }}
      >
        {spaceName}
      </Crumb>
    </BreadCrumbs>
  );
};
